import { Component, Input, OnInit } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Observable } from 'rxjs';
import { CaseService } from '../../services/case.service';
import { LookupService } from '../../services/lookup.service';
import { DateFormatterService } from '../date-picker/date-formatter.service';
import { SharedHttpService } from './../../services/shared-http.service';

@Component({
  selector: 'app-prosecution-decision',
  templateUrl: './prosecution-decision.component.html',
  styleUrls: ['./prosecution-decision.component.scss']
})
export class ProsecutionDecisionComponent implements OnInit {
  @Input() eCaseId: any;
  @Input() loadDataFP: Observable<any>;
  prosecutionDecisionsArr:any=[];
  previewObj:any;
  public loadfromparent = new BehaviorSubject<any>('');
  caseDetials: any;
  isInsert: any;
  ProsecutionDecsionId: any;
  isFinal:boolean;
  hasPunishment:boolean;
  remarks:string='';
  courtId:any;
  court:any;
  judgeId:any;
  judgeName:any;
  decisionNumber:any;
  orderDateHJ:any;
  today = new Date();
  currentDate: NgbDateStruct;
  constructor(private dateformat: DateFormatterService,public sharedService: SharedHttpService, public lookupservice: LookupService, public caseservice: CaseService) { }

  ngOnInit(): void {
    this.caseDetials = this.caseservice.case;
    this.currentDate = this.sharedService.convertDateToNgbDateStruct(this.today);

    this.loadDataFP.subscribe((data) => {
      setTimeout(() => {
          this.loadData();
      }, 100);
    });
  }
  loadData(){
      this.sharedService.get(`api/Case/GetProsecutionDecisions?ecaseId=${this.eCaseId}`).subscribe(res=>{
      this.prosecutionDecisionsArr=res;
    })

  }
  SelectedDateChange($event) {
    this.orderDateHJ = this.dateformat.ToHijri2($event);
  }
  previewProsecutionDecision(prosecutionDecsionId, modal) {
    this.loadfromparent.next({ "id": prosecutionDecsionId, "IsReadOnly": true });
      this.sharedService.get(`api/Case/GetProsecutionDecision?ProsecutionDecisionId=${prosecutionDecsionId}`).subscribe(res=>{
      this.previewObj = {};
      this.previewObj = res;
      this.sharedService.openLarge(modal);
    });
  }
  AddProsecution(modal) {
    this.ProsecutionDecsionId = null;
    this.loadfromparent.next({ "id": 0, "IsReadOnly": false }); 
    this.isInsert = true;
    this.isFinal = undefined;
    this.hasPunishment = undefined;
    this.remarks='';
    this.courtId=undefined;
    this.court=undefined;
    this.judgeId=undefined;
    this.judgeName=undefined;
    this.decisionNumber=undefined;
    this.orderDateHJ=undefined;
    this.sharedService.openXLarge(modal);
  }
  chaneIsFinal(isfinal){
    this.isFinal=isfinal;
  }
  chaneHasPunishment(hasPunish){
    this.hasPunishment=hasPunish;
  }
  onCreateRecord() {
    this.sharedService.post("api/Case/AddProsecutionDecision", {
      "caseId": this.caseservice.case.caseId,
      "isfinal": this.isFinal,
      "haspunishment": this.hasPunishment,
      "remarks": this.remarks,
      "courtid": this.courtId,
      "court": this.court,
      "judgeid": this.judgeId,
      "judgename": this.judgeName,
      "decisionnumber": this.decisionNumber,
      "orderdatehj": this.orderDateHJ,
    }).subscribe(res => {
        this.ProsecutionDecsionId = res.prosecutionDecsionId;
        this.loadfromparent.next({ "id": this.ProsecutionDecsionId, "IsReadOnly": false });
        this.sharedService.showSuccessKey('DescriptionAddedSuccessfully');
        this.isInsert = false;
        this.loadData();
    });
  }
  AddAttachmentModal(modal, pid, IsReadOnly) {
    this.loadfromparent.next({ "id": pid, "IsReadOnly": IsReadOnly }); 
    this.sharedService.openXLarge(modal);
  }

  deleteProsecution(modal,ProsecutionDecsionId:any) {
      this.sharedService.openSmall(modal);
      this.ProsecutionDecsionId = ProsecutionDecsionId;
  }

  onDelete(modal) {
      this.sharedService.get(`api/Case/DeleteProsecutionDecision?ProsecutionDecisionId=${this.ProsecutionDecsionId}`).subscribe(res => {
          if (res == true) {
              this.loadData();
              this.sharedService.showSuccessKey("DeletedSuccessfully");
              modal.dismiss('Cross click');
          }
      });
  }
  numberOnly(event) {
    var inp = String.fromCharCode(event.keyCode);
    let pattern =/^\d+$/;
    if (pattern.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
}
